export enum PROVINCES {
  CATAMARCA = 3,
  CABA = 2,
}
